/**
 * @generated SignedSource<<62191de49521615f03b332b99d3625b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleVariant_viewer">;
  readonly " $fragmentType": "HpSharedShopByModule_viewer";
};
export type HpSharedShopByModule_viewer$key = {
  readonly " $data"?: HpSharedShopByModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrendingCreatorsVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModule_viewer",
  "selections": [
    {
      "condition": "isTrendingCreatorsVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedShopByModuleVariant_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bcdcac7f2c8c10b178ce7c4340b882e9";

export default node;
